import Footer from './Footer.jsx';
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js